// extracted by mini-css-extract-plugin
export default {"AnnotationToolbar":"_AnnotationToolbar--Y78s8"};